export const getProductPurchaseId = (id: string): string => {
  const now = new Date(Date.now());
  const dd = `0${now.getDate()}`.slice(-2);
  const mm = `0${now.getMonth() + 1}`.slice(-2);
  const yy = now.getFullYear().toString().slice(-2);
  return `${id}${dd}${mm}${yy}`;
};
